export default __webpack_public_path__ + "static/media/phone-outlined.28d0081e.svg";